<template>
  <div class="agent-not-logged">
    <img src="@/img/undraw_contact_us_15o2.svg" class="image-not-logged" />
    <p>{{ message }}</p>
    <el-button @click="handleAgentSignIn" v-if="showSignInButton">{{ canSignIn ? $t("agent-console.login") : $t("agent-console.retry")  }}</el-button>
  </div>
</template>

<script>
import agentapi from "@/api/agent";
export default {

  data() {
    return {
      showSignInButton: true,
      showPleaseWait: false,
      canSignIn: true,
    }
  },

  computed: {
    agent() {
      return this.$store.getters['getAgent']
    },  
    message() {
      if (!this.showPleaseWait) {
        if (this.$store.getters['getUserClickTheSignInButton']) {
          return this.$t("agent-console.you-have-logged-out-as-an-agent")+ ". " + this.$t("agent-console.to-login-to-start-receiving", { channels: this.agentResponds })
        }

        if (!this.canSignIn) {
          return this.$t("agent-console.you-cannot-log-in-as-an-agent-because-the-maximum-number-of-agents-has-already-been-reached")
        } else {
          return this.$t("agent-console.not-logged-in-as-an-agent-yet")+ ". " + this.$t("agent-console.to-login-to-start-receiving", { channels: this.agentResponds })
        }
      }

      return this.$t("agent-console.please-wait")
    },
    agentResponds () {
      if (this.agent.call && this.agent.chat) {
        return this.$t("agent-console.calls-and-chats").toLowerCase();
      }

      if (this.agent.call) {
        return this.$t("agent-console.calls").toLowerCase();
      }

      return this.$t("agent-console.chats").toLowerCase();
    }
  },

  methods: {
    fetchIfAgentCanSignIn() {
      return agentapi.fetchIfAgentCanSignIn().then(({ data }) => {
        this.canSignIn = data
      })
    },
    handleAgentSignIn() {
      this.showPleaseWait = true
      this.showSignInButton = false
      this.fetchIfAgentCanSignIn().then(() => {
        if (this.canSignIn) {
          this.$store.dispatch('doLogin').then(() => {
            this.$store.commit('SET_USER_CLICK_SIGN_IN_BUTTON', true)
          })
        } else {
          this.showSignInButton = true
        }
      })
    }
  }
}
</script>

<style scoped>
.agent-not-logged {
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--column)
}

.agent-not-logged img {
  width: 30em;
}
</style>